import React from "react";

import { Link, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import scrollToComponent from "react-scroll-to-component";
import "react-phone-number-input/style.css";
import "react-responsive-ui/style.css";
import Header from "../Header/header";
import TermAndCondition from "../common/termsAndCondition";

import {
  saveBusinessUser,
  saveBusinessUserStep1,
  getAllCountry,
  getAllStates,
  getCityByStateId,
  getAllPlans,
  getAffiliateDetailByAffiliateKey,
  confirmUserEmail,
  clearData,
  getBusiness,
  getIndustry,
  checkEmailVerify,
  getPageData,
  requestApiData,
  clearDataEmail
} from "../../Actions/actions";

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      password: "",
      passwordType: "password",
      companyTitle: "",
      mobilePhone: "",
      workPhoneNumber: "",
      email: "",
      companyName: "",
      streeAddress: "",
      city: "",
      state: "",
      zipCode: "",
      separateTaxId: "",
      enterpriseType: "",
      startingYear: "",
      webSite: "",
      industryTypeId: "",
      taxId: "",
      errors: {},
      cognitoClientId: "",
      bankruptcyStatus: "",
      dissolvedStatus: "",
      acceptCC: "",
      planPriceId: 0,
      isLoading: false,
      businessTypeId: "",
      roleName: "Business-User",
      IsCompanyForm: 1,
      readDisclaimer: "",
      readPrivacyPolicy: "",
      readLetterOfAgency: "",
      readUserAgreement: "",
      errorsCompany: {},
      errorsTermPolicy: {},
      modalIsOpen: false,
      fileError: false,
      totalTaxId: 1,
      file: "",
      code: "",
      indicatorBusiness: "",
      indicatorConsumer: "",
      signatureImageContentType: "image/png",
      signatureImageFileSize: "",
      errorForcodeverify: false,
      isMounted: false,
      affiliateId: "",
      partnerType: "",
      defaultIndex: 1,
      countryCode: "+1",
      workCountryCode: "+1",
      cityId: "",
      nonWorkPhoneNumber: "",
      showTab: 1,
      affiliateKeyId: "",
      isLoginCheckS: false,
      plansDataAffiliate1: [],
      indexType: "defaultIndex",
      passwordColor: "black",
      cchangeSignature: 0,
      signatureDefaultValue: "",
      signatureFontFamily: "",
      emptyErrorSign: 1,
      AllPlansForMember1: [],
      intervalId: 0,
      pageType: "business",
      enableButtonT: true,
      userDataLogin1: [],
      isLoader: false,
      BusinessUserDataStep1Data: {},
      cFirstName: "",
      cLastName: "",
      cState: "",
      cSince: "",
      cEmployer: "",
      cEmail: "",
      cPhone: "",
      cPassword: "",
      cNotification: "",
      cUpdateClaim: "",
      serviceFeeAgree: "",
      bankAccount: "",
      otherIndustryType: "",
      selectedPlanName: "",
      selectedPlanAmount: "",
      paymentStatus: "pending"
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.uploadHandler = this.uploadHandler.bind(this);
    this.onPlanSelect = this.onPlanSelect.bind(this);
    this.codeOnSubmit = this.codeOnSubmit.bind(this);
    this.onPlanSelectSubmit = this.onPlanSelectSubmit.bind(this);
    // this.verifyEmail = this.verifyEmail.bind(this);
    this.onPlanSelectBar = this.onPlanSelectBar.bind(this);
    this.handleDataChidData = this.handleDataChidData.bind(this);
    this.backClick = this.backClick.bind(this);
  }

  handleDataChidData(data) {
    this.setState({
      showTab: data
    });
  }

  async componentWillMount() {
    const intervalId = setInterval(
      this.scrollStep.bind(this),
      this.props.delayInMs
    );
    this.setState({ intervalId });
  }

  handleSaveData = async langValue => {
    const { history } = this.props;
    this.setState(
      {
        readDisclaimer: langValue.readDisclaimer,
        readPrivacyPolicy: langValue.readPrivacyPolicy,
        readLetterOfAgency: langValue.readLetterOfAgency,
        readUserAgreement: langValue.readUserAgreement
        //  IsCompanyForm: 5,
      },
      async () => {
        await this.props.saveBusinessUserStep1(this.state);
        await history.push("./signup-signature-page");
      }
    );
    //  const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    //  this.setState({ intervalId1: intervalId });
  };

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  };

  backClick() {
    const {
      history,
      signupData: { BusinessUserDataStep1 }
    } = this.props;

    if (BusinessUserDataStep1.step1 !== undefined) {
      if (BusinessUserDataStep1.step1.defaultIndex === 0) {
        if (
          BusinessUserDataStep1.step1.affiliateKeyId !== "" &&
          BusinessUserDataStep1.step1.affiliateKeyId !== undefined
        ) {
          history.push({
            pathname: `/signup/${BusinessUserDataStep1.step1.affiliateKeyId}`
          });
        } else {
          history.push({ pathname: "/signup" });
        }
      } else {
        history.push({ pathname: "/signup-plan-page" });
      }
    } else {
      history.push({ pathname: "/signup-plan-page" });
    }
    //    this.setState(state => ({
    //      IsCompanyForm: state.IsCompanyForm - 1,
    //    }));
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    this.props.getPageData(7);

    //  this.setState({
    //    intervalId1: 0,
    //  });

    this.setState({ isMounted: true }, () => {
      if (this.state.isMounted) {
        this.setState({ isMounted: false });
        {
          const dataB = {
            lookupTypeId: 1
          };
          const dataI = {
            lookupTypeId: 2
          };

          this.props.getAllStates();
          this.props.getAllCountry();
          this.props.getAllPlans({
            pageNumber: 0,
            pageSize: 20,
            searchKeyword: "",
            planUserType: "Business",
            userId: 0,
            affiliateKey:
              this.props.match.params.affiliateKey !== undefined
                ? this.props.match.params.affiliateKey
                : ""
          });
          this.props.getBusiness(dataB);
          this.props.getIndustry(dataI);
        }
      }
    });
  }

  onPlanSelectBar(id) {
    this.setState({
      planPriceId: id
    });
    this.onPlanSelectSubmit();
  }

  onPlanSelect(e) {
    const id = e.value;
    this.setState({
      planPriceId: id
    });
  }

  onPlanSelectSubmit() {
    const partnerType = this.props.match.params.partnerType;
    if (partnerType === "Both" || typeof partnerType === "undefined") {
      this.setState({
        IsCompanyForm: 4,
        defaultIndex: 1
      });
      scrollToComponent(this.termsAndConditionsRef, {
        offset: 0,
        align: "bottom",
        duration: 500,
        ease: "inExpo"
      });
    } else if (partnerType === "Business") {
      this.setState({
        IsCompanyForm: 1,
        defaultIndex: 1
      });
    } else if (partnerType === "Consumer") {
      this.setState({
        IsCompanyForm: 1,
        defaultIndex: 0
      });
    }
  }

  openModal() {
    this.setState({ modalIsOpen: true, fileError: false });
  }

  afterOpenModal() { }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  fileChangedHandler = event => {
    this.setState({ file: event.target.files[0] });
  };

  uploadHandler = () => { };

  confirmState() {
    this.setState({ errors: {}, IsCompanyForm: 6 });
  }

  codeOnSubmit(e) {
    e.preventDefault();

    if (this.state.code !== "") {
      this.props.confirmUserEmail(this.state);
    } else {
      const errors = {};
      errors.code = "Verification code is Required";
      this.setState({
        errors
      });
    }
  }

  componentWillUnmount() {
    // console.log('ssssssssssssssssssssssssssssssssss /signup-step1', this.props);
    this.props.clearData();
    // const {} = this.props
  }

  componentDidUpdate() {
    const { plansDataAffiliate, userInfo, AllPlansForMember } = this.props.data;

    // const { BusinessUserDataStep1 } = this.props;
    const {
      match: { params },
      signupData: { BusinessUserDataStep1 }
    } = this.props;
    const { BusinessUserDataStep1Data } = this.state;

    const plainDto = {};

    if (BusinessUserDataStep1.step1 !== undefined) {
      if (BusinessUserDataStep1Data !== BusinessUserDataStep1) {
        this.setState({
          BusinessUserDataStep1Data: BusinessUserDataStep1,
          cFirstName: BusinessUserDataStep1.step1.cFirstName,
          cLastName: BusinessUserDataStep1.step1.cLastName,
          cState: BusinessUserDataStep1.step1.cState,
          cSince: BusinessUserDataStep1.step1.cSince,
          cEmployer: BusinessUserDataStep1.step1.cEmployer,
          cEmail: BusinessUserDataStep1.step1.cEmail,
          cPhone: BusinessUserDataStep1.step1.cPhone,
          cPassword: BusinessUserDataStep1.step1.cPassword,
          cNotification: BusinessUserDataStep1.step1.cNotification,
          cUpdateClaim: BusinessUserDataStep1.step1.cUpdateClaim,
          serviceFeeAgree: BusinessUserDataStep1.step1.serviceFeeAgree,
          bankAccount: BusinessUserDataStep1.step1.bankAccount,
          otherIndustryType: BusinessUserDataStep1.step1.otherIndustryType,

          firstName: BusinessUserDataStep1.step1.firstName,
          lastName: BusinessUserDataStep1.step1.lastName,
          signatureDefaultValue:
            BusinessUserDataStep1.step1.signatureDefaultValue,
          companyTitle: BusinessUserDataStep1.step1.companyTitle,
          email: BusinessUserDataStep1.step1.email,
          password: BusinessUserDataStep1.step1.password,
          workPhoneNumber: BusinessUserDataStep1.step1.workPhoneNumber,
          nonWorkPhoneNumber: BusinessUserDataStep1.step1.nonWorkPhoneNumber,
          companyName: BusinessUserDataStep1.step1.companyName,
          acceptCC: BusinessUserDataStep1.step1.acceptCC,
          bankruptcyStatus: BusinessUserDataStep1.step1.bankruptcyStatus,
          dissolvedStatus: BusinessUserDataStep1.step1.dissolvedStatus,
          totalTaxId: BusinessUserDataStep1.step1.totalTaxId,
          streeAddress: BusinessUserDataStep1.step1.streeAddress,
          city: BusinessUserDataStep1.step1.city,
          state: BusinessUserDataStep1.step1.state,
          zipCode: BusinessUserDataStep1.step1.zipCode,
          separateTaxId: BusinessUserDataStep1.step1.separateTaxId,
          enterpriseType: BusinessUserDataStep1.step1.enterpriseType,
          startingYear: BusinessUserDataStep1.step1.startingYear,
          webSite: BusinessUserDataStep1.step1.webSite,
          industryTypeId: BusinessUserDataStep1.step1.industryTypeId,
          taxId: BusinessUserDataStep1.step1.taxId,
          planPriceId: BusinessUserDataStep1.step1.planPriceId,
          readDisclaimer: BusinessUserDataStep1.step1.readDisclaimer,
          readPrivacyPolicy: BusinessUserDataStep1.step1.readPrivacyPolicy,
          readLetterOfAgency: BusinessUserDataStep1.step1.readLetterOfAgency,
          readUserAgreement: BusinessUserDataStep1.step1.readUserAgreement,
          defaultIndex: BusinessUserDataStep1.step1.defaultIndex,

          caffiliateId: BusinessUserDataStep1.step1.caffiliateId,
          caffiliateKey: BusinessUserDataStep1.step1.caffiliateKey,

          affiliateId: BusinessUserDataStep1.step1.affiliateId,
          affiliateKeyId: BusinessUserDataStep1.step1.affiliateKeyId,
          selectedPlanName: BusinessUserDataStep1.step1.selectedPlanName,
          selectedPlanAmount: BusinessUserDataStep1.step1.selectedPlanAmount,
          paymentStatus: BusinessUserDataStep1.step1.paymentStatus,

          cRoleName: BusinessUserDataStep1.step1.cRoleName,
          roleName: BusinessUserDataStep1.step1.roleName

          // showTab: 2,
          // IsCompanyForm: 2,
        });
      }
    }

    const {
      plansDataAffiliate1,
      AllPlansForMember1,
      userDataLogin1
    } = this.state;
    if (userInfo !== undefined) {
      if (typeof userInfo.user !== "undefined") {
        if (userDataLogin1 !== userInfo) {
          this.setState({
            userDataLogin1: userInfo
          });
          this.context.router.history.push("/dashboard");
        }
      }
    }

    if (plansDataAffiliate !== undefined) {
      if (params.affiliateKey !== undefined) {
        if (plansDataAffiliate.result !== undefined) {
          if (plansDataAffiliate.result.affiliateActive === 1) {
            if (plansDataAffiliate1 !== plansDataAffiliate) {
              Object.assign(plainDto, {
                records: plansDataAffiliate.result.affiliateSubscriptionDto.map
              });
              this.setState({
                plansDataAffiliate1: plansDataAffiliate,
                AllPlansForMember1: plainDto,
                affiliateId: plansDataAffiliate.result.userId,
                isLoader: false
              });
              if (plansDataAffiliate.result.affiliateType === "Both") {
                this.setState({
                  IsCompanyForm: 1,
                  defaultIndex: 1
                });
              } else if (
                plansDataAffiliate.result.affiliateType === "Business"
              ) {
                this.setState({
                  IsCompanyForm: 1,
                  defaultIndex: 1,
                  showTab: 2,
                  indicatorBusiness: "active",
                  indicatorConsumer: ""
                });
              } else if (
                plansDataAffiliate.result.affiliateType === "Consumer"
              ) {
                this.setState({
                  defaultIndex: 0,
                  showTab: 2,
                  indicatorBusiness: "",
                  indicatorConsumer: "active"
                });
              }
              this.props.getAllPlans({
                pageNumber: 0,
                pageSize: 20,
                searchKeyword: "",
                planUserType: "Business",
                userId:
                  plansDataAffiliate.result.userId !== undefined
                    ? plansDataAffiliate.result.userId
                    : 0,
                affiliateKey:
                  this.props.match.params.affiliateKey !== undefined
                    ? this.props.match.params.affiliateKey
                    : ""
              });
            }
          } else {
            this.context.router.history.push("/signup-disabled");
          }
        }
      }
    }
    if (AllPlansForMember !== undefined) {
      if (params.affiliateKey === undefined) {
        if (AllPlansForMember.records !== undefined) {
          if (AllPlansForMember.records.Small !== undefined) {
            if (AllPlansForMember.records.Small.length > 0) {
              if (AllPlansForMember1 !== AllPlansForMember) {
                this.setState({
                  AllPlansForMember1: AllPlansForMember
                });
              }
            }
            // console.log("Asdsasaa",AllPlansForMember.records.Small)
          }
        }
      }
    }
  }

  render() {
    const { pageType, enableButtonT } = this.state;

    return (
      <span>
        <div className="container">
          <div className="main-content">
            <Header />
            <div className="white-box">
              <div className="section-content create-account">
                <div className="row">
                  <div className="col s12 m10 offset-m1">
                    <div className="row">
                      <div className="col s12 m6 create-acc-hdr">
                        <h5> Create Account </h5>
                      </div>
                      <div className="col s12 m6 already-acc">
                        <Link to="/">Already have an account?</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-content left-align term-condition">
                <div className="row">
                  <div className="col s12 m10 offset-m1">
                    <div className="row">
                      <div className="col s12">
                        <h4>
                          Collectively monitors, files and helps you collect
                          from antitrust and class action settlements. In order
                          for us to be able to act on your behalf, we need you
                          to agree to the following
                        </h4>
                      </div>
                    </div>

                    <div className="row">
                      <TermAndCondition
                        termsAndConditionData={this.handleSaveData}
                        termsAndConditionBack={this.backClick}
                        pageType={pageType}
                        backButton={enableButtonT}
                        termsData={this.state}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

Signup.contextTypes = {
  router: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  data: state.data,
  signupData: state.signupData
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveBusinessUser,
      saveBusinessUserStep1,
      getAllCountry,
      getAllStates,
      getCityByStateId,
      getAffiliateDetailByAffiliateKey,
      getAllPlans,
      confirmUserEmail,
      clearData,
      getIndustry,
      getBusiness,
      checkEmailVerify,
      requestApiData,
      getPageData,
      clearDataEmail
    },
    dispatch
  );
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Signup)
);
